/**
 * Triggers a browser download of a value serialized as pretty-printed JSON.
 *
 * @param filename - The download file name.
 * @param payload - The value to serialize and download.
 */
export function triggerJsonDownload(filename: string, payload: unknown) {
   const json = JSON.stringify(payload, null, 2)
   const blob = new Blob([json], { type: 'application/json' })
   const url = URL.createObjectURL(blob)
   const tempLink = document.createElement('a')
   tempLink.href = url
   tempLink.download = filename
   tempLink.rel = 'noopener'
   tempLink.style.display = 'none'
   document.body.appendChild(tempLink)
   tempLink.click()
   document.body.removeChild(tempLink)
   window.setTimeout(() => {
      URL.revokeObjectURL(url)
   }, 1000)
}
